import {
  ISpotlightCollection,
  IMediaImageCard
} from '@pcln/contentful-components'
import analytics from '@/shared-utils/analytics'

function generatePromoImages(mediaCardImages: IMediaImageCard[]) {
  const promoCards = mediaCardImages?.map(mediaCardImage => {
    return {
      backgroundImageUrl: mediaCardImage.backgroundImage?.file?.url,
      callToActionColor: mediaCardImage.callToActionColor,
      callToAction: {
        contentTypeId: mediaCardImage.callToAction?.label ? 'button' : '',
        openInNewTab: mediaCardImage.callToAction?.openInNewTab,
        url: mediaCardImage.callToAction?.url || '',
        buttonText: mediaCardImage.callToAction?.label,
        label: mediaCardImage.callToAction?.label || '',
        onClick: () => {
          analytics.fireEvent({
            category: mediaCardImage.callToAction?.analyticsTracking?.category,
            action: mediaCardImage.callToAction?.analyticsTracking?.action,
            label: mediaCardImage.callToAction?.analyticsTracking?.label
          })
        },
        ariaLabel: mediaCardImage.callToAction?.ariaLabel || ''
      },
      contentAlign: mediaCardImage.contentAlign || 'default',
      logoImageUrl: mediaCardImage.logoImage?.file.url,
      logoImageAlt: mediaCardImage.logoImage?.title,
      showBorder: mediaCardImage.showBorder || false,
      showLogoImageBackground: mediaCardImage.showLogoImageBackground || false,
      fixedLogoSize: mediaCardImage.fixedLogoSize,
      badgeColor: mediaCardImage.badgeColor,
      badgeText: mediaCardImage.badgeText,
      borderText: mediaCardImage.borderText,
      heading: mediaCardImage.heading,
      subheading: mediaCardImage.subheading,
      isCondensed: mediaCardImage.isCondensed,
      backgroundColor: mediaCardImage.backgroundColor
    }
  })
  return promoCards
}
export default function mapSpotlightCollectionContentfulData(
  data: ISpotlightCollection
) {
  const {
    logoImage,
    subheading,
    callToAction,
    backgroundColor,
    spotlightColor,
    mediaCardImages
  } = data
  return {
    primaryLogoImageUrl: logoImage?.asset.file.url,
    primaryLogoImageAlt: logoImage?.altText,
    primarySubheading: subheading,
    backgroundColor,
    spotlightColor,
    callToAction: {
      url: callToAction?.url,
      buttonText: callToAction?.label,
      ariaLabel: callToAction?.ariaLabel,
      googleAnalyticsTracking: {
        label: callToAction?.analyticsTracking?.label,
        action: callToAction?.analyticsTracking?.action,
        category: callToAction?.analyticsTracking?.category
      }
    },
    promoCards: mediaCardImages && generatePromoImages(mediaCardImages)
  }
}
